<template>
  <div>
    <div
      v-for="item in items"
      :key="`items-${item.pk}`"
      class="assingItem elevation-1"
    >
      <!-- Información del item si es suborden -->
      <v-col cols="12" sm="6" md="4">
        <p class="assingItem__title mb-0">{{ item.name }}</p>

        <!-- Código de la suborden -->
        <p class="assingItem__title">
          {{ `${$tc('code', 2)}: ` }}
          <span class="text-aux">{{ item.code }}</span>
        </p>

        <!-- Nombre del producto -->
        <div v-if="!isDriver">
          <p class="assingItem__body mb-0">{{ $tc('product', 1) }}:</p>
          <p class="assingItem__text">{{ item.own_prod }}</p>
        </div>
        <div v-if="isDriver" class="d-flex flex-row align-items-center">
          <!-- Foto del item si es un conductor -->
          <v-list-item-avatar size="60" color="grey darken-3">
            <i-image :value="item.photo" :preview="true" :readonly="true" />
          </v-list-item-avatar>

          <!-- Nombre del conductor o el producto de la suborden -->
          <span>
            {{ `${item.first_name} ${item.last_name}` }}
          </span>
        </div>
      </v-col>

      <!-- Asignación de usuario o mensaje de alerta si no se puede asignar -->
      <v-col cols="12" sm="6" md="8">
        <assign-user
          v-if="isProducerAssignable(item)"
          :selectedItem="item.pk"
          :mode="mode"
          :template="item.template"
        />
        <v-alert v-else type="info" outlined color="primary">
          <span class="primary--text font-weight-black">
            {{ $t('assignProduction_no') }}
          </span>
        </v-alert>
      </v-col>
    </div>
  </div>
</template>

<script>
import AssignUser from './infoAssignItem.vue'

export default {
  components: {
    AssignUser
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      default: 'designer'
    }
  },
  computed: {
    isDriver() {
      return this.mode === 'driver'
    }
  },
  methods: {
    /**
     * isProducerAssignable
     * Método para determinar si un productor puede ser asignado a una suborden
     * basada en el modo 'production' y el estado de la orden.
     *
     * @param {Object} item - El objeto de la suborden que contiene información
     * para la asignación.
     * @returns {boolean} - Devuelve verdadero si el productor puede ser
     * asignado, de lo contrario, devuelve falso.
     *
     * Rosana Mendez <rosanamendez5 at gmail.com>
     */
    isProducerAssignable(item) {
      const validModes = ['delivery', 'driver', 'designer']
      const invalidOrderStatuses = [
        'design_under_review - in_wait',
        'design - in_wait',
        'design - in_design'
      ]
      const isValidMode = validModes.includes(this.mode)
      const isProduction = this.mode === 'production'
      const isOrderStatusInvalid = invalidOrderStatuses.includes(
        item.orderStatus
      )
      const isOrderStatusValid =
        item.orderStatus === '' ||
        item.orderStatus === 'design - finished' ||
        item.orderStatus === 'production - in_wait' ||
        item.orderStatus === 'production - finished'
      return (
        isValidMode ||
        (isProduction && !isOrderStatusInvalid && isOrderStatusValid)
      )
    }
  }
}
</script>
<style lang="sass">
.assingItem
  display: flex
  flex-wrap: wrap
  margin-bottom: 16px
  border-radius: 10px
  padding: 0 .5rem

.theme--light
  .assingItem
    background-color: rgb(0 0 0 / 3%)
    border: 1px solid rgb(0 0 0 / 0.26)
    border-left: 5px solid var(--v-primary-base)

.theme--dark
  .assingItem
    background-color: rgb(40 40 40)
    border: 1px solid rgb(255 255 255 / 0.16)
    border-left: 5px solid var(--v-primary-base)

.assingItem__title
  color: var(--v-primary-base)
  font-family: "Roboto", sans-serif
  font-size: 1.25rem
  font-weight: 900
  letter-spacing: 0.0125em
  line-height: 2rem
  @media (600px > width)
    font-size: 1rem
    letter-spacing: 0.009375em
    line-height: 1.75rem

.assingItem__body
  color: var(--v-primary-base)
  font-size: .9rem
  font-weight: 500
.assingItem__text
  font-size: 1rem
  font-weight: 400
</style>
